import { render, staticRenderFns } from "./ModalUnidadeEmprestimo.vue?vue&type=template&id=1dec2643&"
import script from "./ModalUnidadeEmprestimo.vue?vue&type=script&lang=js&"
export * from "./ModalUnidadeEmprestimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports